<template>
    <nav class="fixed z-10 bg-white xl:bg-opacity-0 xl:absolute w-full">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between py-2 lg:py-3 xl:pt-2">
                <div class="flex items-start">
                    <div class="flex-shrink-0">
                        <a :href="homeUrl" title="home" class="lg:hidden">
                            <slot name="logo-mobile"/>
                        </a>
                        <div class="xl:mr-10">
                            <a :href="homeUrl" title="home" class="hidden lg:block lg:mr-10">
                                <slot name="logo-desktop"/>
                            </a>
                        </div>
                    </div>
                    <div class="hidden lg:block sm:ml-12">
                        <div class="flex space-x-5 xl:space-x-12">
                            <slot name="desktop-navigation"/>
                        </div>
                    </div>
                </div>
                <div class="hidden sm:ml-6 lg:block">
                    <div class="flex items-center">
                        <div>
                            <div>
                                <button
                                    class="bg-green-500 hover:bg-green-600 flex items-center py-1 justify-center space-x-3 w-56 text-white font-carter transform rotate-3 rounded text-lg relative z-10"
                                    @click="playcornerDropdownIsOpen = !playcornerDropdownIsOpen">
                                    <span>{{ lennyTitle }}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor" class="w-5 h-5"
                                         :class="playcornerDropdownIsOpen ? 'hidden' : 'block'">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M19 9l-7 7-7-7"/>
                                    </svg>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor" class="w-5 h-5"
                                         :class="playcornerDropdownIsOpen ? 'block' : 'hidden'">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M5 15l7-7 7 7"/>
                                    </svg>
                                </button>
                                <transition
                                    enter-active-class="transition ease-out duration-100"
                                    enter-from-class="transform opacity-0 scale-95"
                                    enter-to-class="transform opacity-100 scale-100"
                                    leave-active-class="transition ease-in duration-75"
                                    leave-from-class="transform opacity-100 scale-100"
                                    leave-to-class="transform opacity-0 scale-95"
                                >
                                    <div
                                        class="rounded-b-md shadow-lg py-1 bg-green-500 w-56 transform rotate-3 absolute z-0 -ml-1 -mt-1"
                                        role="menu"
                                        aria-orientation="vertical"
                                        aria-labelledby="user-menu"
                                        :class="playcornerDropdownIsOpen ? 'block' : 'hidden'"
                                    >
                                        <slot name="playcorner-desktop-dropdown"/>
                                    </div>
                                </transition>
                            </div>
                        </div>
                        <div class="ml-10 relative">
                            <div>
                                <button
                                    class="flex items-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white flex-shrink-0 space-x-1"
                                    id="user-menu"
                                    aria-haspopup="true"
                                    @click="countryDropdownIsOpen = !countryDropdownIsOpen"
                                >
                                    <slot name="current-locale-desktop"/>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                         stroke="currentColor" class="w-4 h-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M19 9l-7 7-7-7"/>
                                    </svg>
                                </button>
                            </div>
                            <transition
                                enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95"
                            >
                                <div
                                    class="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="user-menu"
                                    :class="countryDropdownIsOpen ? 'block' : 'hidden'"
                                >
                                    <slot name="locales-desktop"/>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="-mr-2 flex lg:hidden">
                    <button
                        class="inline-flex items-center justify-center p-2 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        aria-expanded="false"
                        @click="isOpen = !isOpen"
                    >
                        <span class="sr-only">Open main menu</span>
                        <svg
                            class="h-6 w-6"
                            :class="isOpen ? 'hidden' : 'block'"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                        </svg>
                        <svg
                            class="h-6 w-6"
                            :class="isOpen ? 'block' : 'hidden'"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="lg:hidden" :class="isOpen ? 'block' : 'hidden'">
            <div class="pt-2">
                <div class="flex justify-end px-3 py-2">
                    <div class="flex space-x-2">
                        <slot name="locales-mobile"/>
                    </div>
                </div>
                <div class="space-y-1">
                    <slot name="mobile-navigation"/>
                </div>
                <div>
                    <slot name="playcorner-mobile-dropdown"/>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: "NavBar",
    props: [
        'lennyTitle',
        'homeUrl'
    ],
    data: () => ({
        isOpen: false,
        countryDropdownIsOpen: false,
        playcornerDropdownIsOpen: false
    })
};
</script>

<style scoped>

</style>
